import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { useRedirectUrl } from "../../application-data/redirect"
import { authorize, singleLogout } from "../../auth/auth0"
import { MagentoPath, Path } from "../../navigation/constants/routes"
import useServerConnection from "../../hooks/use-server-connection.hook"
import UserIcon from "../../images/icons/user.inline.svg"
import UserIconWhite from "../../images/icons/user-white.inline.svg"
import { BaseLink } from "../../ui/components/link/link.component"
import Modal from "./dropdown-modal.component"
import { connect } from "react-redux"
import { RootState } from "../../store"
import { clearUser } from "../../auth"
import { User } from "../../auth/dto/user.object"
import { isMagentoStoreActive } from "../../constants/e-commerce"
import useTranslationHook from "../../hooks/use-translation.hook"
import { AppFunctionComponent } from "../../types"

const AvatarIcon = styled.img`
  border-radius: 50%;
  width: 35px;
  height: 35px;
`

const AvatarWrapper = styled.div`
  cursor: pointer;
`

const getUserPicture = (user: User | null) => {
  return user?.avatar ?? ""
}

const mapStateToProps = (state: RootState) => {
  return {
    user: state.auth.data.user,
  }
}

const mapDispatchToProps = {
  clearUser,
}

type StateProps = ReturnType<typeof mapStateToProps> & {
  clearUser: () => void
  className?: string
  isDark?: boolean
}

const Avatar: AppFunctionComponent<StateProps> = ({
  className,
  user,
  clearUser,
  isDark,
}) => {
  const [menuModalVisible, setMenuModalVisible] = useState(false)
  // url to come back from redirect page
  const [, setBackRedirectUrl] = useRedirectUrl()
  // full url of redirect page (current origin + Path.Redirect)
  const [redirectUrl, setRedirectUrl] = useState("")
  const [authId, setAuthId] = useState("")
  const connection = useServerConnection()
  const { language, translate } = useTranslationHook()

  const saveRedirectPath = (event: React.MouseEvent): void => {
    event.preventDefault()
    if (window.location.pathname !== Path.Redirect.toString()) {
      const currentUrl = window.location.href
      setBackRedirectUrl(currentUrl)
    }
    authorize(redirectUrl, language)
  }

  const modalElements = [
    {
      title: translate("account-my-cart"),
      link: isMagentoStoreActive() ? MagentoPath.Cart : Path.Cart,
    },
    {
      title: translate("account-my-orders"),
      link: isMagentoStoreActive() ? MagentoPath.Orders : Path.Orders,
    },
    ...(isMagentoStoreActive()
      ? [
          { title: translate("account-my-account"), link: MagentoPath.Account },
          { title: translate("account-my-address"), link: MagentoPath.Address },
        ]
      : []),
    {
      title: translate("account-log-out"),
      onClick: (event: React.MouseEvent) => {
        event.preventDefault()
        clearUser()
        singleLogout(redirectUrl, authId)
        setAuthId("")
      },
      target: "_self",
    },
  ]

  const handleOnClick = () => {
    setMenuModalVisible(true)
  }

  const handleHideModal = () => {
    setMenuModalVisible(false)
  }

  useEffect(() => {
    const url = window.location.origin + Path.Redirect
    setRedirectUrl(url)

    // void checkSession((_, authResult) => {
    //   if (!authResult) {
    //     if (!user) {
    //       return
    //     }
    //     clearUser()
    //     setAuthId("")
    //   } else {
    //     if (!user) {
    //       const {
    //         accessToken,
    //         idTokenPayload: {
    //           sub: userId,
    //           email,
    //           nickname,
    //           picture,
    //           name,
    //           preferred_username: username,
    //         },
    //       } = authResult
    //       setAuthId(userId)

    //       //NORMAL FETCHING USER WAS VERY LONG 4-5 SEC, THIS TEMPORARY USER IS SOMETHING LIKE PLACEHOLDER, ONLY DATA MISSING IS user_metadata
    //       saveUser(
    //         JSON.stringify({
    //           user_id: userId,
    //           email,
    //           nickname,
    //           picture,
    //           name,
    //           username,
    //           user_metadata: {},
    //         })
    //       )

    //       //Very long time of Fetching on PROD. WE FETCH THIS BEHIND SCENES, AND REPLACE TEMPORARY USER IN FLY.
    //       fetchUserSilent(accessToken, userId, (res) => {
    //         saveUser(JSON.stringify(res))
    //       })
    //     }
    //   }
    // }, url)
  }, [])

  return connection ? (
    user ? (
      <AvatarWrapper onClick={handleOnClick} className={className}>
        <AvatarIcon src={getUserPicture(user)} alt={"Profile"} />
        {menuModalVisible && (
          <Modal elements={modalElements} hideModal={handleHideModal} />
        )}
      </AvatarWrapper>
    ) : (
      <BaseLink
        className={className}
        target="_self"
        onClick={saveRedirectPath}
        aria-label={"User profile"}
      >
        {isDark ? <UserIconWhite /> : <UserIcon aria-hidden="true" />}
      </BaseLink>
    )
  ) : null
}

export default connect(mapStateToProps, mapDispatchToProps)(Avatar)
